import React from 'react';
export function EyedropperIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.414 11l3.793-3.793a3.121 3.121 0 10-4.414-4.414L13 6.586l-1.293-1.293-1.414 1.414L11.586 8l-7.438 7.438-2.076 5.19 1.3 1.3 5.19-2.076L16 12.414l1.293 1.293 1.414-1.414L17.414 11zm-2.828 0L13 9.414l-7.148 7.148-1.057 2.643 2.643-1.057L14.586 11z"
  }));
}